module.exports = __webpack_public_path__ + "static/index/img/baikal-210.baa65765.jpg";